function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var ErrorWithCause = require('@uppy/utils/lib/ErrorWithCause');
/**
 * Check that Assembly parameters are present and include all required fields.
 */


function validateParams(params) {
  if (params == null) {
    throw new Error('Transloadit: The `params` option is required.');
  }

  if (typeof params === 'string') {
    try {
      // eslint-disable-next-line no-param-reassign
      params = JSON.parse(params);
    } catch (err) {
      // Tell the user that this is not an Uppy bug!
      throw new ErrorWithCause('Transloadit: The `params` option is a malformed JSON string.', {
        cause: err
      });
    }
  }

  if (!params.auth || !params.auth.key) {
    throw new Error('Transloadit: The `params.auth.key` option is required. ' + 'You can find your Transloadit API key at https://transloadit.com/c/template-credentials');
  }
}
/**
 * Combine Assemblies with the same options into a single Assembly for all the
 * relevant files.
 */


function dedupe(list) {
  var dedupeMap = Object.create(null);

  var _iterator = _createForOfIteratorHelper(list),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          fileIDs = _step$value.fileIDs,
          options = _step$value.options;

      var _id = JSON.stringify(options);

      if (_id in dedupeMap) {
        dedupeMap[_id].fileIDArrays.push(fileIDs);
      } else {
        dedupeMap[_id] = {
          options: options,
          fileIDArrays: [fileIDs]
        };
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return Object.values(dedupeMap).map(function (_ref) {
    var options = _ref.options,
        fileIDArrays = _ref.fileIDArrays;
    return {
      options: options,
      fileIDs: fileIDArrays.flat(1)
    };
  });
}
/**
 * Turn Transloadit plugin options and a list of files into a list of Assembly
 * options.
 */


var _getAssemblyOptions = /*#__PURE__*/_classPrivateFieldLooseKey("getAssemblyOptions");

var AssemblyOptions = /*#__PURE__*/function () {
  function AssemblyOptions(files, opts) {
    _classCallCheck(this, AssemblyOptions);

    Object.defineProperty(this, _getAssemblyOptions, {
      value: _getAssemblyOptions2
    });
    this.files = files;
    this.opts = opts;
  }
  /**
   * Get Assembly options for a file.
   */

  /**
   * Generate a set of Assemblies that will handle the upload.
   * Returns a Promise for an object with keys:
   *  - fileIDs - an array of file IDs to add to this Assembly
   *  - options - Assembly options
   */


  _createClass(AssemblyOptions, [{
    key: "build",
    value: function () {
      var _build = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var options, assemblyOptions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = this.opts;

                if (!(this.files.length > 0)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Promise.all(this.files.map(function (file) {
                  return _classPrivateFieldLooseBase(_this, _getAssemblyOptions)[_getAssemblyOptions](file);
                })).then(dedupe));

              case 3:
                if (!options.alwaysRunAssembly) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return options.getAssemblyOptions(null, options);

              case 6:
                assemblyOptions = _context.sent;
                validateParams(assemblyOptions.params);
                return _context.abrupt("return", [{
                  fileIDs: this.files.map(function (file) {
                    return file.id;
                  }),
                  options: assemblyOptions
                }]);

              case 9:
                return _context.abrupt("return", []);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function build() {
        return _build.apply(this, arguments);
      }

      return build;
    }()
  }]);

  return AssemblyOptions;
}();

function _getAssemblyOptions2(_x) {
  return _getAssemblyOptions3.apply(this, arguments);
}

function _getAssemblyOptions3() {
  _getAssemblyOptions3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
    var options, assemblyOptions;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = this.opts;
            _context2.next = 3;
            return options.getAssemblyOptions(file, options);

          case 3:
            assemblyOptions = _context2.sent;

            if (Array.isArray(assemblyOptions.fields)) {
              assemblyOptions.fields = Object.fromEntries(assemblyOptions.fields.map(function (fieldName) {
                return [fieldName, file.meta[fieldName]];
              }));
            } else if (assemblyOptions.fields == null) {
              assemblyOptions.fields = {};
            }

            validateParams(assemblyOptions.params);
            return _context2.abrupt("return", {
              fileIDs: [file.id],
              options: assemblyOptions
            });

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _getAssemblyOptions3.apply(this, arguments);
}

module.exports = AssemblyOptions;
module.exports.validateParams = validateParams;